import {
  ASSET,
  BUTTON,
  CHART,
  CONTAINER,
  CONTENT,
  EXTERNAL_FORM,
  FORM,
  GROUP,
  HTML,
  IFRAME,
  IMAGE,
  LINE,
  LIVE_ELEMENT,
  MENU,
  RECTANGLE,
  SEEK,
  SHAPE,
  TEXT,
  VIDEO,
} from '../../../constants/widgetTypes';

const FLEX_FLOW_CONFIG = {
  [TEXT]: {preserveWidth: true},
  [BUTTON]: { preserveSize: true },
  [SHAPE]: { preserveSize: true },
  [RECTANGLE]: { preserveSize: true },
  [LINE]: { preserveSize: true },
  [IMAGE]: { preserveSize: true },
  [CONTAINER]: { preserveWidth: true },
  [MENU]: { preserveSize: true },
  [SEEK]: { preserveSize: true },
  [CONTENT]: { preserveSize: true },
  [FORM]: { preserveSize: true },
  [EXTERNAL_FORM]: { preserveSize: true },
  [IFRAME]: { preserveSize: true },
  [HTML]: { preserveSize: true },
  [CHART]: { preserveSize: true },
  [VIDEO]: { preserveSize: true },
  [ASSET]: { preserveSize: true },
  [LIVE_ELEMENT]: { preserveSize: true },
  [GROUP]: { preserveSize: true },
};

export function getFlexFlowConfig(type) {
  return FLEX_FLOW_CONFIG[type] || {};
}
